// @ts-nocheck

/**
 * FIXME
 * [description]
 * @param  {[type]} state  [description]
 * @param  {[type]} action [description]
 * @return {[type]}        [description]
 */
const basketDelFreebet = (state, action) => {
  const { freebetId } = action.payload;
  const { freebets } = state;
  return {
    ...state,
    freebets: {
      ...freebets,
      [freebetId]: {
        ...freebets[freebetId],
        deleted: true,
      },
    },
  };
};

export default basketDelFreebet;
